import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HttpService  {
  
private city = "/common/empCities";
private campus = "/common/empCityCampuses?cityId=";
private courseTrack = "/courseFeeMaster/campusWiseCTs?campusId=";
private classAndStream = "/courseFeeMaster/campusWiseClassStreamList?campusId="
private list = "/courseFeeMaster/campusClassStreamWiseCFDetails?campusId=";
private secondpagelist = "/courseFeeMaster/cctInfo?campusId="
private groups="/courseFeeMaster/campusClassWiseGroupList?campusId="
private tax="/courseFeeMaster/orgWiseStateGSTDetails?campusId="
private savepost="/courseFeeMaster/saveCCFDetails"
private details='/courseFeeMaster/ccfHeadWiseApprovalList?courseFeeId='
private orglist="/common/allOrganizationList"
private org="&orgId="
private transhead="&transHeadId="
private filterby = "&filterBy=";
private class = "&classId=";
private stream = "&streamId=";
private campusTrackId = "&campusTrackId="
private courseTrackId="&courseTrackId="
private token = "eyJhbGciOiJIUzI1NiJ9.eyJwYXlyb2xsSWQiOiJIWUQxMDMxMzUiLCJtb2JpbGVObyI6IjAiLCJ0eXBlIjoiTWFzdGVyU2VydmljZSIsImV4cCI6MTcxNDcxNTEwNiwidXNlcklkIjoiSFlEMTAzMTM1IiwiaWF0IjoxNzE0NjI4NzA2LCJ1bmlxdWVJZCI6Mjg0ODYsImp0aSI6IjI0OTIxMjdiLWZmNzYtNDYxNC1iMzgyLWJmMzU4MmI5YWIzYSJ9.l3IUXUeD6H2o0azsdrzMxS2arr23y3rBMIWskHdSoFU";
dynamicUrl: any;
private groupid: string="&groupId=";
constructor(private http: HttpClient, private dtservice: DataService,) { }
getCity() {
  const headers= new HttpHeaders({
    'Authorization': this.token,
  });
  return this.http.get(environment.CourseFeeUrl+this.city, { headers });
}
getCampus(cityid: any) {
  this.dynamicUrl = this.campus + cityid;
  const headers= new HttpHeaders({
    'Authorization': this.token,
  });
  return this.http.get(environment.CourseFeeUrl+this.dynamicUrl, { headers });
}
getCourseTrack(campusId: any, classId: any, streamId: any) {
  this.dynamicUrl = environment.CourseFeeUrl+this.courseTrack + campusId + this.class + classId + this.stream + streamId;
  const headers= new HttpHeaders({
    'Authorization': this.token,
  });
  return this.http.get(this.dynamicUrl, { headers });

}
getClassAndStream(campusId: any) {
  this.dynamicUrl = environment.CourseFeeUrl+this.classAndStream + campusId;
  const headers= new HttpHeaders({
    'Authorization': this.token,
  });
  return this.http.get(this.dynamicUrl, { headers });

}
getList(campusId: any, classId: any, streamId: any, filterby: any,courseTrackId:any,groupid:any) {
  this.dynamicUrl = environment.CourseFeeUrl+this.list + campusId + this.class + classId + this.stream + streamId + this.filterby + filterby+this.groupid+groupid+this.courseTrackId+courseTrackId;
  const headers= new HttpHeaders({
    'Authorization': this.token,
  });
  return this.http.get(this.dynamicUrl, { headers });
}
getsecondpagelist(campusId:any,classId:any,streamId:any,campusTrackId:any) {
  this.dynamicUrl = environment.CourseFeeUrl+this.secondpagelist + campusId + this.class + classId + this.stream + streamId + this.campusTrackId + campusTrackId;
  const headers= new HttpHeaders({
    'Authorization': this.token,
  });
  return this.http.get(this.dynamicUrl, { headers });
}
getGroup( campusId:any,classId:any)
{
  this.dynamicUrl = environment.CourseFeeUrl+this.groups + campusId+ this.class+classId  ;
  const headers= new HttpHeaders({
    'Authorization': this.token,
  });
  return this.http.get(this.dynamicUrl, { headers });
}
getTax(campusId:any,orgId:any,transHeadId:any)
{
  this.dynamicUrl = environment.CourseFeeUrl+this.tax+campusId+this.org+orgId+this.transhead+transHeadId ;
  const headers= new HttpHeaders({
    'Authorization': this.token,
  });
  return this.http.get(this.dynamicUrl, { headers });
}
savedata(payload: any) {
  const headers= new HttpHeaders({
    'Authorization': this.token,
  });
  return this.http.post(environment.CourseFeeUrl+this.savepost, payload, { headers })
}
getdetails(coursefeeid:any)
{
  this.dynamicUrl = environment.CourseFeeUrl+this.details+coursefeeid;
  // console.log(this.dynamicUrl)
  const headers= new HttpHeaders({
    'Authorization': this.token,
  });
  return this.http.get(this.dynamicUrl, { headers });
}
getorglist()
{
  const headers= new HttpHeaders({
    'Authorization': this.token,
  });
  return this.http.get(environment.CourseFeeUrl+this.orglist, { headers });
}
}